import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field col required py-0 px-2" }
const _hoisted_2 = { class: "field-checkbox flex flex-row justify-content-between my-1" }

import { ref, watch, toRefs } from 'vue';
import { Weekday, WeekdayStr } from 'rrule';
import { EMIT, RRULE_WEEKDAY } from '@/enum';
import ToggleButton from 'primevue/togglebutton';
interface Props {
  selectedValues: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WeekdayPicker',
  props: {
    selectedValues: {}
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { selectedValues } = toRefs(props);
const selectedRecurringWeekdays = ref<number[]>(selectedValues.value);
const recurringWeekdays = ref<{ label: string; value: boolean }[]>(
  [...Object.keys(RRULE_WEEKDAY)]
    // we only need the keys that are day strings
    .filter((value) => isNaN(Number(value)))
    .map((value, i) => {
      // if they are editting an event that has a custom recurrence
      // we need to auto select the weekdays they previously had
      const toggled = Array.isArray(selectedRecurringWeekdays.value)
        ? selectedRecurringWeekdays.value.includes(i)
        : false;
      return { label: value, value: toggled };
    }),
);

watch(
  () => recurringWeekdays,
  (weekdays) => {
    selectedRecurringWeekdays.value = [];

    weekdays.value.forEach((day) => {
      if (day.value) {
        const rRuleDay: WeekdayStr = day.label.toUpperCase() as WeekdayStr;
        selectedRecurringWeekdays.value.push(Weekday.fromStr(rRuleDay).weekday);
      }
    });

    emit(EMIT.UPDATE, selectedRecurringWeekdays.value);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("label", { for: "weekday_buttons" }, "Repeat on", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recurringWeekdays.value, (weekday) => {
        return (_openBlock(), _createBlock(_unref(ToggleButton), {
          key: weekday.label,
          modelValue: weekday.value,
          "onUpdate:modelValue": ($event: any) => ((weekday.value) = $event),
          "on-label": weekday.label,
          "off-label": weekday.label
        }, null, 8, ["modelValue", "onUpdate:modelValue", "on-label", "off-label"]))
      }), 128))
    ])
  ]))
}
}

})